import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import * as signalR from '@microsoft/signalr';
import { environment } from '../environments/environment';

export interface ReactionCountPush {
  postId: number;
  Replies: number;
  Reposts: number;
  Likes: number;
}

@Injectable({ providedIn: 'root' })
export class ReactionHubService {
  private readonly countsSubject = new Subject<ReactionCountPush>();
  readonly reactionCounts$: Observable<ReactionCountPush> = this.countsSubject.asObservable();
  private started = false;
  private connection: signalR.HubConnection | null = null;

  start(): void {
    if (this.started) {
      return;
    }
    this.started = true;
    const base = (environment.apiBaseUrl ?? '').replace(/\/$/, '');
    const url = base ? `${base}/hubs/reactions` : '/hubs/reactions';

    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(url, { withCredentials: true })
      .withAutomaticReconnect()
      .build();

    this.connection.on('ReactionCountsUpdated', (payload: any) => {
      const postId = Number(payload?.postId ?? payload?.PostId);
      const react = payload?.reactions ?? payload?.Reactions;
      if (!react || Number.isNaN(postId)) {
        return;
      }
      const Replies = Number(react.Replies ?? react.replies ?? 0);
      const Reposts = Number(react.Reposts ?? react.reposts ?? 0);
      const Likes = Number(react.Likes ?? react.likes ?? 0);
      this.countsSubject.next({ postId, Replies, Reposts, Likes });
    });

    this.connection.start().catch(err => console.error('[SignalR] reactions hub:', err));
  }
}
